export default __webpack_public_path__ + "static/media/val9.b106711f.png";